import { Language, LanguageDirection } from "@types";

export const LANGUAGE_DIRECTIONS: Record<Language, LanguageDirection> = {
  [Language.EN]: LanguageDirection.LTR,
  [Language.TH]: LanguageDirection.LTR,
  [Language.ID]: LanguageDirection.LTR,
  [Language.BN]: LanguageDirection.LTR,
  [Language.TL]: LanguageDirection.LTR,
  [Language.ES]: LanguageDirection.LTR,
  [Language.PT]: LanguageDirection.LTR,
  [Language.HI]: LanguageDirection.LTR,
  [Language.UR]: LanguageDirection.RTL,
  [Language.AR]: LanguageDirection.RTL,
};
